module.exports = __webpack_public_path__ + "img/banner_img.335898f1.png";